import { IsInt, IsEmail, IsString, IsDateString, IsNumber, IsDate, IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty, ValidateNested } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';

export class NotifyPartyDTO {
    @ApiProperty()
    @IsNotEmpty({ message: "notify party id should not be empty" })
    @IsAlphanumeric()
    notifyPartyId?: number;

    @ApiProperty()
    @IsNotEmpty({ message: "notify Party Name should not be empty" })
    @IsAlphanumeric()
    @IsOptional()
    notifyPartyName: string;

    @ApiProperty()
    isActive: boolean;

    createdAt: Date;

    @ApiProperty()
    @IsOptional()
    @MaxLength(50, { message: "Created User allows maximum 50 characters" })
    @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"), { message: "created user should be only numbers" })
    createdUser: string;

    updatedAt: Date;
    @ApiProperty()
    @IsOptional()
    @MaxLength(50, { message: "Updated User allows maximum 50 characters" })
    @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"), { message: "updated user should be only numbers" })
    updatedUser: string;


    @ApiProperty()
    versionFlag: number;
}